import { calculateKDA } from "lib/general-helper.js";

export function formatSummonerChampionStats(data) {
  if (!Array.isArray(data)) {
    return [];
  }

  let noDupes = {};
  const notAddable = ["maxKills", "maxDeaths"];
  for (const champion of data) {
    if (noDupes[champion.championId]) {
      for (const [key, value] of Object.entries(champion)) {
        if (key !== "championId") {
          if (notAddable.includes(key)) {
            if (noDupes[champion.championId][key]) {
              noDupes[champion.championId][key] = Math.max(noDupes[champion.championId][key], value);
            } else {
              noDupes[champion.championId][key] = value;
            }
          } else {
            noDupes[champion.championId][key] = parseInt(noDupes[champion.championId][key]) + parseInt(value);
          }
        }
      }
    } else {
      noDupes[champion.championId] = { ...champion };
    }
  }
  noDupes = Object.values(noDupes);

  const formattedData = noDupes.map((champion, index) => {
    const {
      assists,
      championId,
      cs,
      damage,
      damageTaken,
      deaths,
      gold,
      kills,
      maxDeaths,
      maxKills,
      totalMatches,
      wins,
      doubleKills,
      tripleKills,
      quadraKills,
      pentaKills,
    } = champion;

    const winRate = Math.round(((wins || 0) / totalMatches) * 1000) / 10;
    const losses = totalMatches - (wins || 0);
    const avgKills = (Math.round(((kills || 0) / totalMatches) * 10) / 10).toFixed(1);
    const avgDeaths = (Math.round(((deaths || 0) / totalMatches) * 10) / 10).toFixed(1);
    const avgAssists = (Math.round(((assists || 0) / totalMatches) * 10) / 10).toFixed(1);
    const ratio = calculateKDA(kills || 0, deaths || 0, assists || 0);
    const avgCs = Math.round(((cs || 0) / totalMatches) * 10) / 10;
    const avgGold = Math.round((gold || 0) / totalMatches);
    const avgDamage = Math.round((damage || 0) / totalMatches);
    const avgDamageTaken = Math.round((damageTaken || 0) / totalMatches);

    return {
      championId,
      played: {
        value: totalMatches,
        totalMatches,
        wins: wins || 0,
        losses,
        winRate,
      },
      winRate,
      kda: {
        ratio,
        avgKills,
        avgDeaths,
        avgAssists,
      },
      avgGold,
      avgCs,
      maxKills: maxKills || 0,
      maxDeaths: maxDeaths || 0,
      avgDamage,
      avgDamageTaken,
      doubleKills: doubleKills || 0,
      tripleKills: tripleKills || 0,
      quadraKills: quadraKills || 0,
      pentaKills: pentaKills || 0,
      ...champion,
    };
  });

  return formattedData;
}
